// --- PATCHED: make card wishlist use variantId, update aria, and listen for detailed changes ---
(function () {
  function getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  }

  function saveWishlist(wishlist) {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    // Notify general listeners
    document.dispatchEvent(new CustomEvent('wishlistUpdated', { detail: { list: wishlist } }));
  }

  function showWishlistMessage(msg, color) {
    // reuse your site's toast helper if available; minimal fallback:
    if (window.showWishlistMessage) return window.showWishlistMessage(msg, color);
    console.info('[wishlist]', msg);
  }

  function dispatchDetailedChange(variantId, action, item) {
    try {
      document.dispatchEvent(new CustomEvent('wishlist:change', {
        detail: { variantId, action, item, list: getWishlist() }
      }));
    } catch (err) {
      console.error('wishlist:change dispatch error', err);
    }
  }

  function toggleCardWishlist(button) {
    // ensure dataset variant is present (fallback)
    let vId = button.dataset.variantId;
    if (!vId) {
      const form = button.closest('form') || document.querySelector('form');
      const input = form?.querySelector('input[name="id"]');
      if (input?.value) {
        vId = input.value;
        button.dataset.variantId = vId;
      }
    }

    const productId = button.dataset.productId;
    const productTitle = button.dataset.productTitle || '';
    const variantTitle = button.dataset.variantTitle || '';
    const productImg = button.dataset.productImg;
    const productPrice = button.dataset.productPrice;
    const productUrl = button.dataset.productUrl;

    if (!vId) return;

    let wishlist = getWishlist();
    const index = wishlist.findIndex(item => item.variantId === String(vId));
    const wasWishlisted = index !== -1;
    const fullTitle = variantTitle ? `${variantTitle} - ${productTitle}` : productTitle;

    if (wasWishlisted) {
      // remove
      wishlist.splice(index, 1);
      button.classList.remove('is-active');
      button.classList.remove('wishlisted');
      button.setAttribute('aria-pressed', 'false');
      showWishlistMessage(`Removed ${fullTitle} from Wishlist`, 'red');
    } else {
      // add
      const newItem = {
        productId,
        variantId: String(vId),
        variantTitle,
        productTitle,
        productImg,
        productPrice,
        productUrl,
        addedAt: new Date().toISOString()
      };
      wishlist.unshift(newItem);
      button.classList.add('is-active');
      button.classList.add('wishlisted');
      button.setAttribute('aria-pressed', 'true');
      showWishlistMessage(`Added ${fullTitle} to Wishlist`, 'green');
    }

    saveWishlist(wishlist);

    // Emit a detailed change so other scripts can react to the specific variant
    const action = wasWishlisted ? 'removed' : 'added';
    dispatchDetailedChange(vId, action, wasWishlisted ? null : wishlist[0]);
  }

  function initCardWishlistButtons(scope = document) {
    const buttons = (scope || document).querySelectorAll('.card-wishlist-button');
    const wishlist = getWishlist();

    buttons.forEach(button => {
      // prefer variantId when checking state; if missing, try to populate it
      let variantId = button.dataset.variantId;
      if (!variantId) {
        const form = button.closest('form') || document.querySelector('form');
        const input = form?.querySelector('input[name="id"]');
        variantId = input?.value;
        if (variantId) button.dataset.variantId = variantId;
      }

      // now check by variantId (canonical)
      const isWishlisted = variantId ? wishlist.some(item => item.variantId === String(variantId)) : false;

      // Keep visual parity with PDP: toggle both classes and set aria
      button.classList.toggle('is-active', isWishlisted);
      button.classList.toggle('wishlisted', isWishlisted);
      button.setAttribute('aria-pressed', isWishlisted ? 'true' : 'false');

      // Avoid duplicate listeners
      if (button._wishlistHandler) button.removeEventListener('click', button._wishlistHandler);
      button._wishlistHandler = (e) => {
        e.preventDefault();
        toggleCardWishlist(button);
      };
      button.addEventListener('click', button._wishlistHandler);
    });
  }

  // Re-init on DOM ready
  document.addEventListener('DOMContentLoaded', () => initCardWishlistButtons());

  // Re-init when wishlist changes or when Shopify re-renders sections
  document.addEventListener('wishlistUpdated', (e) => {
    // e.detail?.list is available, but we simply re-init buttons to reflect current storage
    initCardWishlistButtons();
  });

  document.addEventListener('shopify:section:load', (e) => initCardWishlistButtons(e.target));

  // Targeted update: respond to a detailed change event so we only touch the affected button(s)
  document.addEventListener('wishlist:change', (e) => {
    try {
      const detail = e.detail || {};
      const variantId = detail.variantId;
      const action = detail.action; // 'added' | 'removed'
      if (!variantId) return;

      // Update any card buttons for this variant
      const selector = `.card-wishlist-button[data-variant-id="${variantId}"], .card-wishlist-button[data-variant-id="${String(variantId)}"]`;
      const btns = document.querySelectorAll(selector);
      btns.forEach(btn => {
        const nowWishlisted = action === 'added';
        btn.classList.toggle('is-active', nowWishlisted);
        btn.classList.toggle('wishlisted', nowWishlisted);
        btn.setAttribute('aria-pressed', nowWishlisted ? 'true' : 'false');
      });
    } catch (err) {
      // fail silently but log for debugging
      console.error('Error handling wishlist:change in card script', err);
    }
  });

  // Optional: expose for debugging
  window._initCardWishlistButtons = initCardWishlistButtons;
})();
